import React, { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";

const InterviewSchedule = () => {

  const [interviews, setInterviews] =
    useState([]);

  const [showModal, setShowModal] =
    useState(false);

  const [commentType, setCommentType] =
    useState("");

  const [selectedInterview, setSelectedInterview] =
    useState(null);

  const [commentText, setCommentText] =
    useState("");

  const [searchBy, setSearchBy] =
    useState("");

  const [searchValue, setSearchValue] =
    useState("");
    

  // FETCH DATA

  const fetchInterviews = async () => {

    try {

      const response = await Axios.get(
        "/api/jobs/scheduled-interviews"
      );

      setInterviews(response.data.data || []);

    } catch (error) {

      console.log(error);

    }

  };

  // SEARCH FUNCTION

  const handleSearch = () => {

    if (!searchBy || !searchValue) {

      fetchInterviews();

      return;

    }

    const filtered = interviews.filter(
      (item) =>

        item[searchBy]
          ?.toString()
          .toLowerCase()
          .includes(
            searchValue.toLowerCase()
          )
    );

    setInterviews(filtered);

  };

  // USE EFFECT

  useEffect(() => {

    fetchInterviews();

  }, []);

  // OPEN MODAL

const openCommentModal = (
  item,
  type
) => {

  setSelectedInterview(item);

  setCommentType(type);

  setCommentText("");

  setShowModal(true);

};

  // SAVE COMMENT

  const saveComment = async () => {

    try {

      const updatedComments = {

        admin:
          commentType === "admin"
            ? commentText
            : selectedInterview?.comments
                ?.admin || "",

        partner:
          commentType === "partner"
            ? commentText
            : selectedInterview?.comments
                ?.partner || ""

      };

      await Axios.put(
        `/api/jobs/scheduled-interviews/${selectedInterview.id}`,
        {
          comments: updatedComments
        }
      );

      alert("Comment Saved");
      

      setShowModal(false);

      fetchInterviews();

    } catch (error) {

      console.log(error);

    }

  };

  // TABLE STYLE

  const thStyle = {
    padding: "14px",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "700",
    color: "#111"
  };

  const tdStyle = {
    padding: "14px",
    fontSize: "15px",
    color: "#222",
    verticalAlign: "middle"
  };

  return (

    <div
      style={{
        padding: "25px",
        background: "#f4f6f9",
        minHeight: "100vh"
      }}
    >

      {/* HEADING */}

      <center>

        <h1
          style={{
            fontSize: "34px",
            fontWeight: "700",
            color: "#1c1c1c",
            marginBottom: "30px",
            letterSpacing: "1px"
          }}
        >
          SCHEDULED INTERVIEWS
        </h1>

      </center>

      {/* SEARCH PANEL */}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "18px",
          flexWrap: "wrap",
          marginBottom: "25px"
        }}
      >

        <h3
          style={{
            margin: 0,
            fontWeight: "600"
          }}
        >
          Search By :
        </h3>

        {/* SELECT */}

        <select
          className="form-select"
          value={searchBy}
          onChange={(e) =>
            setSearchBy(e.target.value)
          }
          style={{
            width: "220px",
            height: "45px",
            borderRadius: "12px",
            border: "1px solid #dcdcdc",
            fontSize: "16px",
            boxShadow: "none"
          }}
        >

          <option value="">
            Select
          </option>

          <option value="studentId">
            Student ID
          </option>

          <option value="studentName">
            Student Name
          </option>

          <option value="businessName">
          Business Name
          </option>

          <option value="jobId">
            Job ID
          </option>

        </select>

        {/* INPUT */}

        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          value={searchValue}
          onChange={(e) =>
            setSearchValue(e.target.value)
          }
          style={{
            width: "320px",
            height: "45px",
            borderRadius: "12px",
            border: "1px solid #dcdcdc",
            fontSize: "16px",
            paddingLeft: "15px"
          }}
        />

        {/* SEARCH BUTTON */}

        <button
          onClick={handleSearch}
          style={{
            background:
              "linear-gradient(to right, #662dff, #7b2cff)",
            color: "#fff",
            border: "none",
            height: "45px",
            padding: "0px 24px",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          Search
        </button>

        {/* REMOVE FILTER */}

        <button
          onClick={() => {

            setSearchBy("");

            setSearchValue("");

            fetchInterviews();

          }}
          style={{
            background: "#0d6efd",
            color: "#fff",
            border: "none",
            height: "45px",
            padding: "0px 24px",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          Remove Filter
        </button>

      </div>

      {/* TABLE */}

      <div
  
  style={{
    background: "#fff",
    borderRadius: "15px",
    padding: "10px",
    boxShadow:
      "0px 2px 10px rgba(0,0,0,0.08)",

    overflow: "auto",

    height: "70vh",

    scrollbarWidth: "thin"
  }}

>

        <table
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "1400px"
          }}
        >

          <thead>

            <tr
              style={{
                background: "#ffffff",
                borderBottom:
                  "2px solid #e5e5e5"
              }}
            >

              <th style={thStyle}>S.No</th>
              <th style={thStyle}>Student ID</th>
              <th style={thStyle}>Student Name</th>
              <th style={thStyle}>Business Name</th>
              <th style={thStyle}>Job Role</th>
              <th style={thStyle}>Job ID</th>
              <th style={thStyle}>Scheduled Date</th>
              <th style={thStyle}>Comments</th>
              <th style={thStyle}>Status</th>
              <th style={thStyle}>Link</th>

            </tr>

          </thead>

          <tbody>

            {interviews.length > 0 ? (

              interviews.map((item, index) => (

                <tr
                  key={item.id}
                  style={{
                    borderBottom:
                      "1px solid #ececec"
                  }}
                >

                  <td style={tdStyle}>
                    {index + 1}
                  </td>

                  <td style={tdStyle}>
                    {item.studentId}
                  </td>

                  <td style={tdStyle}>
                    {item.studentName}
                  </td>
                  <td style={tdStyle}>
                    {item.businessName || "-"}
                  </td>

                  {/* JOB ROLE */}

                  <td
                    style={{
                      ...tdStyle,
                      maxWidth: "250px",
                      lineHeight: "28px"
                    }}
                  >
                    {item.jobRole}
                  </td>

                  <td style={tdStyle}>
                    {item.jobId}
                  </td>

                  <td style={tdStyle}>
                    {item.meetingDate}{" "}
                    {item.meetingTime}
                  </td>

                  {/* COMMENTS */}

                  <td style={tdStyle}>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center"
                      }}
                    >

                      <button
                        onClick={() =>
                          openCommentModal(
                            item,
                            "admin"
                          )
                        }
                        style={{
                          background: "#0d6efd",
                          color: "#fff",
                          border: "none",
                          padding: "4px 10px",
                          minWidth: "65px",
                          height: "30px",
                          borderRadius: "6px",
                          fontWeight: "500",
                          cursor: "pointer",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Admin
                      </button>

                      <button
                        onClick={() =>
                          openCommentModal(
                            item,
                            "partner"
                          )
                        }
                        style={{
                          background: "#198754",
                          color: "#fff",
                          border: "none",
                          padding: "4px 10px",
                          minWidth: "65px",
                          height: "30px",
                          borderRadius: "6px",
                          fontWeight: "500",
                          cursor: "pointer",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Partner
                      </button>

                    </div>

                  </td>

                  {/* STATUS */}

                  <td style={tdStyle}>

                    <span
                      style={{
                        padding:
                          "7px 18px",
                        borderRadius:
                          "20px",
                        color: "#fff",
                        fontWeight: "600",
                        fontSize: "13px",
                        background:
                          item.status ===
                          "Selected"
                            ? "#198754"
                            : item.status ===
                              "Rejected"
                            ? "#dc3545"
                            : "#ffc107"
                      }}
                    >
                      {item.status ||
                        "No Show"}
                    </span>

                  </td>

                  {/* LINK */}

                  <td style={tdStyle}>

                    <a
                      href={item.meetingLink}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#0d6efd",
                        fontWeight: "600",
                        textDecoration:
                          "none"
                      }}
                    >
                      Join
                    </a>

                  </td>

                </tr>

              ))

            ) : (

              <tr>

                <td
                  colSpan="9"
                  style={{
                    textAlign: "center",
                    padding: "30px",
                    fontSize: "18px"
                  }}
                >
                  No Scheduled Interviews Found
                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>
      {/* COMMENT MODAL */}

{showModal && (

  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999
    }}
  >

    {/* ADMIN MODAL */}

    {commentType === "admin" ? (

      <div
        style={{
          width: "58%",
          background: "#fff",
          borderRadius: "12px",
          overflow: "hidden"
        }}
      >

        {/* HEADER */}

        <div
          style={{
            padding: "18px 22px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >

          <h2
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: "700"
            }}
          >
            Admin Comments
          </h2>

          <span
            onClick={() =>
              setShowModal(false)
            }
            style={{
              fontSize: "42px",
              cursor: "pointer",
              color: "#777",
              lineHeight: "30px"
            }}
          >
            ×
          </span>

        </div>

        {/* BODY */}

        <div
          style={{
            padding: "20px"
          }}
        >

          <div
            style={{
              display: "flex",
              gap: "15px",
              alignItems: "flex-start"
            }}
          >

           <textarea
  value={commentText}
  onChange={(e) =>
    setCommentText(e.target.value)
  }
  placeholder="Enter Admin Comment"
  rows="5"
  style={{
    flex: 1,
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "14px",
    fontSize: "18px",
    resize: "none"
  }}
/>

            <div
              style={{
                display: "flex",
                gap: "10px"
              }}
            >

             <button
  onClick={saveComment}
  style={{
    background: "#0d6efd",
    color: "#fff",
    border: "none",
    padding: "8px 18px",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    height: "45px",
    cursor: "pointer"
  }}
>
  Save
</button>

  <button
  onClick={() => {

    setCommentText(
      selectedInterview?.comments?.admin || ""
    );

  }}
  style={{
    background: "#ffc107",
    color: "#fff",
    border: "none",
    padding: "8px 18px",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    height: "45px",
    cursor: "pointer"
  }}
>
  Edit
</button>
            </div>

          </div>

          {/* COMMENT LIST */}

          <div
            style={{
              marginTop: "18px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              padding: "18px",
              fontSize: "18px",
              minHeight: "70px"
            }}
          >

            1. {commentText || "No Comment"}

          </div>

        </div>

      </div>

    ) : (

  /* PARTNER MODAL */

<div
  style={{
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    width: "400px"
  }}
>

  <h3>
    Partner Comment
  </h3>

  <textarea
    value={commentText}
    readOnly
    rows="5"
    style={{
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      marginTop: "10px",
      background: "#f8f9fa",
      resize: "none"
    }}
  />

  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "20px"
    }}
  >

    <button
      onClick={() =>
        setShowModal(false)
      }
      style={{
        background: "#6c757d",
        color: "#fff",
        border: "none",
        padding: "8px 16px",
        borderRadius: "6px",
        cursor: "pointer"
      }}
    >
      Close
    </button>

  </div>

</div>

)}

</div>

)}
    </div>

  );

};

export default InterviewSchedule;